import dayjs from "dayjs";
import { formatUtcScheduledDate } from "app/utils/timezone";

export const getShipmentLoads = (item: any): number => {
  const count = item?.shipment_packages_count;
  if (count == null || count === false) {
    return 0;
  }
  return Number(count) || 0;
};

export const getStageTotalLoads = (stage: any): number =>
  (stage?.items || []).reduce(
    (sum: number, item: any) => sum + getShipmentLoads(item),
    0
  );

export const formatOriginWithInvoices = (item: any): string => {
  const origin = item?.origin || "";
  const invoices = item?.account_invoice_ids;
  const invoiceNames = Array.isArray(invoices)
    ? invoices.map((invoice: any) => invoice?.name).filter(Boolean).join(", ")
    : "";

  if (!origin && !invoiceNames) {
    return "";
  }
  if (!invoiceNames) {
    return origin;
  }
  if (!origin) {
    return invoiceNames;
  }
  return `${origin} / ${invoiceNames}`;
};

export const getRouteName = (item: any): string => {
  const route = item?.route_id;
  if (!route || route === false) {
    return "";
  }
  if (typeof route === "object") {
    return route?.name || "";
  }
  return "";
};

export const formatScheduledDate = (
  value?: string,
  timezone?: string
): string => {
  if (!timezone) {
    if (!value) {
      return "";
    }
    const parsed = dayjs(value);
    if (!parsed.isValid()) {
      return value;
    }
    return parsed.format("MM/DD/YYYY h:mm A");
  }

  return formatUtcScheduledDate(value, timezone);
};
